import { render, staticRenderFns } from "./PuzzleOptionQuestionModal.vue?vue&type=template&id=6322f534&scoped=true&"
import script from "./PuzzleOptionQuestionModal.vue?vue&type=script&lang=js&"
export * from "./PuzzleOptionQuestionModal.vue?vue&type=script&lang=js&"
import style0 from "./PuzzleOptionQuestionModal.vue?vue&type=style&index=0&id=6322f534&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6322f534",
  null
  
)

export default component.exports